export default {
    gate: '',
    version: '', // 默认版本
    module: '', // 默认模块
    key: '', // 设置发送数据的类型是JSON还是BLOB
    filter: function () {
    }, // 默认拦截过滤器
    // inter: function () {}, // 默认拦截器
    list: {
        user: {
            login: {
                url: "/blade-user/login-validate",
                type: "post",
                contentType: 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            // 注册
            register: {
                url: "/blade-user/register",
                type: "post",
                contentType: 'application/x-www-form-urlencoded;charset=UTF-8'
            },
           menustree:{module: '',url: '/blade-system/menu/select', type: 'get',contentType: 'application/x-www-form-urlencoded',},            // 重置密码
            resetting: {
                url: "/blade-user/update-password-code",
                type: "post",
                contentType: 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            loginOut: {gate: "logincenter", module: "pc", url: "/loginOut"},
            //获取用户信息
            getUserInfo: {gate: "logincenter", module: "pc", url: "/user/getUserInfo", type: "post",},
            // 获取验证码
            getCode: {
                url: "/blade-user/sms/register/verify-code",
                type: "post",
                contentType: 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            postCode: {
                url: "/blade-user/sms/verify-code",
                type: "post",
                contentType: 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            menuslist:{module: '',url: '/blade-system/menu/grant-tree', type: 'get',contentType: 'application/x-www-form-urlencoded',},
            testIsDeveloper:{module: '',url: '/developer/developer/isDeveloper', type: 'get',contentType: 'application/x-www-form-urlencoded',},

        },
        accountSettings: {
            accountdetail: {
                url: "/blade-user/info",
                type: "get",
                contentType: 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            update: {url: "/blade-user/update", type: "post",},
            updatephone: {url: "/blade-user/update-phone", type: "post",},
            postCode: {
                url: "/blade-user/sms/account/verify-code",
                type: "post",
                contentType: 'application/x-www-form-urlencoded;charset=UTF-8'
            },
        },
        //我的订单
        myOrder: {
            orderMange: {
                url: "/order/order/page",
                type: "get",
                contentType: 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            cancelOrder: {
                url: "/order/order/cancel",
                type: "post",
                contentType: 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            refund: {url: "/order/order/refund", type: "post"},
            detail: {url: "/order/order/detail", type: "get"},
            invoicdetails: {url: "/receiptApply/receiptApply/detail", type: "get"},
            invoiceList: {url: "/receiptApply/receiptApply/page", type: "get"},
            invoicing: {url: "/receiptApply/receiptApply/receipt-order", type: "get"},
            save: {url: "/receiptApply/receiptApply/save", type: "post"},
        },
        sysTem: {
            sysuser: {
                url: "/blade-user/page",
                type: "get",
                // contentType: 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            systemuserAdd: {module: '', url: '/blade-user/submit', type: 'post'},//用户添加
            systemuserUpdate: {module: '', url: '/blade-user/update', type: 'post'},//编辑用户
            isable: {
                module: '',
                url: '/blade-user/remove',
                type: 'post',
                contentType: 'application/x-www-form-urlencoded;charset=UTF-8'
            },//删除
            rolelist: {module: '', url: '/blade-system/role/page', type: 'get'},//角色权限
            roleadd: {module: '', url: '/blade-system/role/submit', type: 'post'},//角色添加
            roldetail: {module: '', url: '/blade-system/role/detail', type: 'get'},//角色详情
            rolupdate: {module: '', url: 'blade-system/role/update', type: 'post'},//角色修改
            loglist: {module: '', url: '/blade-log/api/list', type: 'get'},
            sysdel: {
                module: '',
                url: '/blade-system/role/remove',
                type: 'post',
                contentType: 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            getName:{module: '', url: 'blade-user/getName', type: 'get'},
        },
        userCenter: {
            accountype: {module: '', url: '/blade-system/role/select', type: 'get'},//角色
        },
        //开发者论坛
        developer: {
            editArticle: {gate: 'forum', module: 'web', url: '/article/edit', type: 'post'}, //编辑文章
            draftBox: {gate: 'forum', module: 'web', url: '/article/draftbox', type: 'post'}, //草稿箱列表
            queryFans: {gate: 'forum', module: 'web', url: '/attention/fens/list', type: 'post'}, //查询粉丝列表
            queryAtten: {gate: 'forum', module: 'web', url: '/attention/list', type: 'post'}, //查询关注列表
            getCacheUser: {gate: 'forum', module: 'web', url: '/get/cache/user', type: 'post'}, //获取用户缓存信息
            enterprise: {gate: 'forum', module: 'web', url: '/user/enterprise/authentication', type: 'post'}, //企业认证
            individual: {gate: 'forum', module: 'web', url: '/user/personal/authentication', type: 'post'}, //个人认证
            enterpriseList: {gate: 'forum', module: 'web', url: '/user/enterprise/list/auto', type: 'post'}, //企业查询
            updateIdentify: {gate: 'forum', module: 'web', url: '/user/updata/authentication', type: 'post'}, //修改认证信息查询
            updateAvatar: {gate: 'logincenter', module: 'pc', url: '/user/changeHeadPicture', type: 'post'}, // 修改头像
            updatePwd: {gate: 'logincenter', module: 'pc', url: '/user/updatePwd', type: 'post'}, // 修改密码
            updatePhone: {gate: 'logincenter', module: 'pc', url: '/user/changePhone', type: 'post'}, // 修改手机号
            updateNick: {gate: 'logincenter', module: 'pc', url: '/user/changeNickName', type: 'post'}, // 修改昵称
            getIdentify: {gate: 'forum', module: 'web', url: '/user/get/developer/authentication', type: 'post'}, //认证表认证信息查询
            getUser: {
                url: '/blade-auth/oauth/token',
                type: 'post',
                contentType: 'application/x-www-form-urlencoded;charset=UTF-8',
                filter: function (da) {
                    if (da.access_token) {
                        // console.log("我登录了吗？")
                        localStorage.setItem("token", da.access_token);
                    } else {
                        console.log("登录失败");
                    }
                    return da;
                },
            }, //获取用户信息
            article: {gate: 'forum', module: 'web', url: '/featured/bytime/article', type: 'post'}, //查询文章列表
            follow: {gate: 'forum', module: 'web', url: '/featured/follow/article', type: 'post'}, //关注动态
            myArticle: {gate: 'forum', module: 'web', url: '/article/my/article', type: 'post'}, //我的文章
            articleInfo: {gate: 'forum', module: 'web', url: '/article/article/info', type: 'post'}, //文章详情
            aboutShare: {gate: 'forum', module: 'web', url: '/article/article/share', type: 'post'}, //相关分享
            defaultComment: {gate: 'forum', module: 'web', url: '/comment/default', type: 'post'}, //文章默认评论
            publishComment: {gate: 'forum', module: 'web', url: '/comment/save', type: 'post'}, //发布评论
            reply: {gate: 'forum', module: 'web', url: '/comment/reply', type: 'post'}, //回复
            querylikeordislike: {gate: 'forum', module: 'web', url: '/likeordislike/exist', type: 'post'}, // 查询是否点赞/踩
            likeordislike: {gate: 'forum', module: 'web', url: '/likeordislike/save', type: 'post'}, //点赞、踩
            likeRemove: {gate: 'forum', module: 'web', url: '/likeordislike/remove', type: 'post'}, //取消点赞、踩
            report: {gate: 'forum', module: 'web', url: '/comment/reporting', type: 'post'}, //举报
            myCollect: {gate: 'forum', module: 'web', url: '/collection/list', type: 'post'}, //我的收藏
            myCriticism: {gate: 'forum', module: 'web', url: '/article/my/comment', type: 'post'}, //我的评论
            deleteCriticism: {gate: 'forum', module: 'web', url: '/comment/delete', type: 'post'}, //删除评论
            myNews: {gate: 'forum', module: 'web', url: '/message/list', type: 'post'}, //我的消息
            deleteNews: {gate: 'forum', module: 'web', url: '/message/delete', type: 'post'}, //删除消息
            countNumAll: {gate: 'forum', module: 'web', url: '/count/num/all', type: 'post'}, //关注、粉丝、数量
            saveArticle: {gate: "forum", module: "web", url: "/article/save", type: "post",}, //保存文章
            saveDraft: {gate: "forum", module: "web", url: "/article/save", type: "post",}, //保存草稿
            exist: {gate: 'forum', module: 'web', url: '/attention/exist', type: 'post'}, //查询是否关注
            attention: {gate: 'forum', module: 'web', url: '/attention/save', type: 'post'}, //关注
            cancelAttention: {gate: 'forum', module: 'web', url: '/attention/remove', type: 'post'}, //取消关注
            collectArticle: {gate: 'forum', module: 'web', url: '/collection/save', type: 'post'}, //收藏文章
            collectExist: {gate: 'forum', module: 'web', url: '/collection/exist', type: 'post'}, //查询是否收藏文章
            removeCollect: {gate: 'forum', module: 'web', url: '/collection/remove', type: 'post'}, //取消收藏
            getCoin: {gate: 'forum', module: 'coinAccount', url: '/searchAccount', type: 'post'}, //查询金币账户
            rewardArticle: {gate: 'forum', module: 'web', url: '/record/save/gratuity', type: 'post'}, //打赏
            mechanismList: {gate: 'emp', module: 'api', url: '/mechanism/model/page', type: 'post'}, //机理模型库
            appData: {gate: 'emp', module: 'web', url: '/view/app', type: 'get'},
            modelData: {gate: 'emp', module: 'web', url: '/view/model', type: 'get'},
            mechanismDetail: {gate: 'emp', module: 'api', url: '/mechanism/model/info', type: 'post'}, //机理模型详情
            mechanismChart: {gate: 'emp', module: 'api', url: '/mechanism/model/getRealTimeTrend', type: 'post'}, //机理模型趋势图-实时
            mechanismChartHistory: {
                gate: 'emp',
                module: 'api',
                url: '/mechanism/model/getHistoricalTrend',
                type: 'post'
            }, //机理模型趋势图-历史
            mechanismChartSet: {gate: 'emp', module: 'api', url: '/mechanism/model/setPointByColor', type: 'post'}, //机理模型趋势图-设置
        },
        integrate: {
            getNewsList: {gate: '', module: 'internetAdmin', url: '/news/listNewsPublished', type: 'post'},
            getNewsDetail: {gate: '', module: 'internetAdmin', url: '/news/getNewsDetails', type: 'post'},
            onlineSub: {gate: '', module: 'internetAdmin', url: '/records/save', type: 'post'},
            jobSave: {gate: '', module: 'internetAdmin', url: '/job/app/save', type: 'post'},
        },
        market: {
            marketList: {gate: '', module: 'internetAdmin', url: '/app/market/list', type: 'get'},//应用市场列表
            marketDetails: {gate: '', module: 'internetAdmin', url: '/app/market/get', type: 'get'}//应用市场详情
        },
        operateManage: {
            getSupplyDemandListFn: {module: '', url: '/supplyDemand/supplyDemand/page', type: 'get'},
            delSupplyDemandListFn: {
                module: '',
                url: '/supplyDemand/supplyDemand/remove',
                type: 'post',
                contentType: 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            supplyDemandSubmitFn: {module: '', url: '/supplyDemand/supplyDemand/submit', type: 'post'},
            workOrderSubmitFn: {module: '', url: '/workOrder/workOrder/submit', type: 'post'},
            getJob: {module: '', url: '/industry/industry/list', type: 'get'},
            getArea: {module: '', url: '/blade-area/area/list', type: 'get'},
            getSupplyDemandDetail: {module: '', url: '/supplyDemand/supplyDemand/detail', type: 'get',},
            getsupplyMessageListFn: {module: '', url: '/supplyMessage/supplyMessage/page', type: 'get'},
            getConsultListFn: {module: '', url: '/consult/consult/page', type: 'get'},
            getConsultInfoFn: {module: '', url: '/consult/consult/detail', type: 'get'},
            deleteConsultFn: {module: '', url: '/consult/consult/deleteConsult', type: 'post',},
            getNoticeListFn: {module: '', url: '/omp-notice/notice/page', type: 'get'},
            noticeDetailFn: {module: '', url: '/omp-notice/notice/detail', type: 'get'},
            getWorkOrderListFn: {module: '', url: '/workOrder/workOrder/page', type: 'get'},
            getworkOrderDetailFn: {module: '', url: '/workOrder/workOrder/detail', type: 'get'},
            delSupplyMessageListFn: {
                module: '',
                url: '/supplyMessage/supplyMessage/remove',
                type: 'post',
                contentType: 'application/x-www-form-urlencoded;charset=UTF-8'
            },

            delWorkOrderListFn: {
                module: '',
                url: '/workOrder/workOrder/remove',
                type: 'post',
                contentType: 'application/x-www-form-urlencoded;charset=UTF-8'
            },
                //门户
                getPortalGatewayListFn: { module: '', url: '/portal/portal/gateway', type: 'get' ,  contentType: 'application/x-www-form-urlencoded;charset=UTF-8'},
                getPortalSupplyDetailFn: { module: '', url: '/portal/portal/supplyDetail', type: 'get' },
                getPortalMessagePageFn: { module: '', url: '/portal/portal/messagePage', type: 'get' },
                getPortalAreaFn: { module: '', url: '/portal/portal/areaBox', type: 'get' },
                getPortalIndustryBoxFn: { module: '', url: '/portal/portal/industryBox', type: 'get' },
                supplyMessageSaveFn: { module: '', url: '/supplyMessage/supplyMessage/save', type: 'post' },
                getPortalNewsChannelsFn: { module: '', url: '/portal/news/channels', type: 'get' },
                getPortalNewsPageFn: { module: '', url: '/portal/news/page', type: 'get' },
                getPortalNewsDetailFn: { module: '', url: '/portal/news/detail', type: 'get' },
                getCompanyFn: { module: '', url: '/supplyDemand/supplyDemand/getCompanyName', type: 'get' },
                getHotNewsFn: { module: '', url: '/portal/news/hot-news', type: 'get' },
                portalNewsUpdateFn: { module: '', url: '/portal/news/update', type: 'post' },
                checkSupplyDemandFn: { module: '', url: 'supplyDemand/supplyDemand/check', type: 'get' },



        },
        product: {
            saveApprove: {module: '', url: '/companyAuth/companyAuthenticate/save', type: 'post'},
            updateApprove: {module: '', url: '/companyAuth/companyAuthenticate/update', type: 'post'},
            getList: {module: '', url: '/payedProduct/payedProduct/list', type: 'get'},
            getTrialList: {module: '', url: '/product/trial/list', type: 'get'},

            delTrial: {
                module: '',
                url: '/product/trial/remove',
                type: 'post',
                contentType: 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            delPayed: {
                module: '',
                url: '/payedProduct/payedProduct/remove',
                type: 'post',
                contentType: 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            getPayedProduct: {
                module: '',
                url: '/payedProduct/payedProduct/grant/query',
                type: 'post',
                contentType: 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            getSaveProduct: {module: '', url: '/payedProduct/payedProduct/grant/save', type: 'post',},
            buyOrder: {module: '', url: '/order/order/buyOrder', type: 'get',},
            creatOrder: {module: '', url: '/order/order/creatOrder', type: 'post',},
            saleConfig: {module: '', url: '/product/product/saleConfig', type: 'get',},
            dictList: {module: '', url: '/protalProduct/protalProduct/dictList', type: 'get',},
            payOrder: {module: '', url: '/order/order/payOrder', type: 'post',},
            getTrial: {module: '', url: '/product/product/trial', type: 'get',},
            trialSubmit: {module: '', url: '/applyTry/applyTry/submit', type: 'post',},
            ApplyTryPage: {module: '', url: '/applyTry/applyTry/page', type: 'get',},
            ApplyTryUpdate: {module: '', url: '/applyTry/applyTry/update', type: 'post',},

        },
        home: {
            getMyProduct: {module: '', url: '/home/home/myProduct', type: 'get'},
            getMyCompany: {module: '', url: '/home/home/myCompany', type: 'get'},
            myNewMessage: {module: '', url: '/home/home/myNewMessage', type: 'get'},
            myOrderMessage: {module: '', url: '/home/home/myOrderMessage', type: 'get'},
            myWorkMessage: {module: '', url: '/home/home/myWorkMessage', type: 'get'},
            getNotice: {module: '', url: '/omp-notice/notice/page', type: 'get'},
            update: {module: '', url: '/home/home/update', type: 'post'},
            MsgSave: {module: '', url: 'portal/portal/consultSave', type: 'post'},
            getBanner:{module: '',url:'/portal/portal/page',type:'get'},
            getChannels:{module: '',url:'/portal/portal/channels',type:'get'},
            getChannelNews:{module: '',url:'/portal/portal/channelNews',type:'get'},
            getMainMenu:{module: '',url:'/portal/portal/menu',type:'get'},
            getTotal:{module: '',url:'/portal/portal/total',type:'get'},
            resolveDetail:{module: '',url:'/portal/portal/resolveDetail',type:'get'},
            detailConfig:{module: '',url:'/protalProduct/protalProduct/detailConfig',type:'get'},
            caseDetail:{module: '',url:'/case/case/detailConfig',type:'get'},
            checkProduct:{module: '',url:'protalProduct/protalProduct/checkProduct',type:'get'},
            checkTryProduct:{module: '',url:'protalProduct/protalProduct/checkTryProduct',type:'get'},




},
        system: {
            getCompanyDetail: {module: '', url: '/companyAuth/companyAuthenticate/detail', type: 'get'},
        },
        cooperation:{
            developerApprove: {module: '', url: '/developer/developer/submit', type: 'post'},
            developerDetail: {module: '', url: '/developer/developer/detail', type: 'get'},
        },
        marketNew:{
            marketPage: {module: '', url: '/microApp/microApp/page', type: 'get'},
            marketDetail: {module: '', url: '/microApp/microApp/detail', type: 'get'},
            marketType: {module: '', url: '/microApp/microApp/appType', type: 'get'},
        }
    }
}
